import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { Draft } from "immer";

export interface CampaignFormState {
    fieldValues: SafeDictionary<string>;
}

export const initialState: CampaignFormState = {
    fieldValues: {},
};

const customCampaignReducer = {
    "Custom/CampaignForm/ClearForm": (draft: Draft<CampaignFormState>) => {
        draft.fieldValues = {};
    },
    "Custom/CampaignForm/SetFieldValue": (
        draft: Draft<CampaignFormState>,
        action: { key: string; value: string },
    ) => {
        draft.fieldValues[action.key] = action.value;
    },
};

export default createTypedReducerWithImmer(initialState, customCampaignReducer);
